
import { computed, onMounted, onUnmounted, ref, watch } from "vue";
import SignaturePad from "signature_pad";
import { showToastError, showToastSuccess } from "@/helpers/notification";
import { i18n } from "@/lang";
import { useStore } from "vuex";
import _ from "lodash";
import { RequestedAction } from "@moderrotech/servers-communication-library/src/types";

export default {
  setup() {
    const store = useStore();
    const canvas = ref(),
      container = ref();
    const points = ref<Record<"time" | "x" | "y", number>[][]>([]);

    const penColor = "#2C18A5";

    let pad: SignaturePad | null = null;

    const getWidth = (): number => container.value.clientWidth,
      getHeight = (): number => container.value.clientHeight;

    const handleResize = () => {
      pad!.clear();

      // timeout added for correct width and height calculation
      window.setTimeout(() => {
        const width = getWidth(),
          height = getHeight();

        canvas.value.width = width;
        canvas.value.height = height;

        /*
        pad!.fromData(
          _.map(points.value, group => ({
            color: penColor,
            points: _.map(group, p => ({
              time: p.time,
              x: p.x * width,
              y: p.y * height
            }))
          }))
        );
		*/
        points.value = [];
      }, 100);
    };

    onMounted(() => {
      store.commit(
        "session/UNSET_REQUESTED_ACTION",
        RequestedAction.hideDrawingPad
      );

      pad = new SignaturePad(canvas.value, {
        penColor,
        onEnd: () => {
          const width = getWidth(),
            height = getHeight();

          points.value.push(
            _.map(_.last(pad!.toData())!.points, p => ({
              time: p.time,
              x: p.x / width,
              y: p.y / height
            }))
          );
        }
      });

      canvas.value.width = getWidth();
      canvas.value.height = getHeight();

      window.addEventListener("resize", handleResize);
    });

    onUnmounted(() => window.removeEventListener("resize", handleResize));

    const isSubmitting = ref(false);

    const close = () => {
      _.forEach(
        [RequestedAction.hideDrawingPad, RequestedAction.showDrawingPad],
        a => store.commit("session/UNSET_REQUESTED_ACTION", a)
      );
    };

    const requestedRemoteActions = computed(
      (): { action: RequestedAction; payload?: any }[] | null =>
        store.state.session.requestedActions
    );

    watch(
      () =>
        !!_.find(
          requestedRemoteActions.value,
          v => v.action === RequestedAction.hideDrawingPad
        ),
      v => {
        if (v) {
          close();
        }
      }
    );

    const handleSubmitClick = () => {
      isSubmitting.value = true;
      store.dispatch("sharing/shareDocument", {
        file: pad!.toDataURL(),
        type: "drawing",
        callback: (data: unknown) => {
          isSubmitting.value = false;
          close();
          showToastSuccess(i18n.global.t("call.success.signaturePad"));
        },
        errorCallback: (err: unknown) => {
          isSubmitting.value = false;
          showToastError(i18n.global.t("call.error.signaturePad"));
        }
      });
    };

    const handleClearClick = () => {
      pad!.clear();
      points.value = [];
    };

    return {
      canvas,
      container,
      handleSubmitClick,
      handleClearClick,
      handleCancelClick: () => close(),
      points,
      isSubmitting
    };
  }
};
